/**
 * Специальные утилиты для обработки языковых параметров
 */
/** 
 * Получить значение языка по умолчанию.
 * Используются настройки браузера и настрока языка Liferay если он есть
 */
export const getDefaultLanguage = () => {
  if (window.Liferay) {
    const localeLiferay =  new Intl.Locale(window.Liferay.ThemeDisplay.getLanguageId().replace('_','-'));
    return localeLiferay.language;
  }
  const localeNavigator = new Intl.Locale(navigator.language);
  return localeNavigator.language;
}

/** Возвращает рекомендуемый язык, с учётом параметра "language" в url. 
 * Если этого параметра нет, то используется значения getDefaultLanguage */
export const getRecommendedLanguage = () => {
  const query = getQuestionOrHashBased(location.href);
  const params = getJsonFromQuery(query);
  const language = params["language"];
  if (typeof language === "string"){
    if (language.length == 2)
      return language.toLowerCase()
    
  }
  return getDefaultLanguage();
} 

export const getQuestionOrHashBased = url => {
  if(!url) 
    url = location.href;
  const question = url.indexOf("?");
  let hash = url.indexOf("#");
  if(hash == -1 && question == -1) 
    return "";
  if(hash == -1) 
    hash = url.length;
  return question == -1 || hash == question+1
    ? url.substring(hash)
    : url.substring(question+1,  (question>hash) ? url.length: hash );
}

export const getJsonFromQuery = query=> {
  const result = {};
  query.split("&").forEach(part => {
    if(!part) return;
    part = part.replaceAll("+", " ");
    const eq = part.indexOf("=");
    let key = eq>-1 ? part.substring(0,eq) : part;
    const val = eq>-1 ? decodeURIComponent(part.substring(eq+1)) : "";
    const from = key.indexOf("[");
    if(from==-1) 
      result[decodeURIComponent(key)] = val;
    else {
      const to = key.indexOf("]",from);
      const index = decodeURIComponent(key.substring(from+1,to));
      key = decodeURIComponent(key.substring(0,from));
      if(!result[key]) 
        result[key] = [];
      if(!index) 
        result[key].push(val);
      else 
        result[key][index] = val;
    }
  });
  return result;
}
